import {
	Column,
	Entity,
	Index,
	JoinColumn,
	ManyToOne,
	OneToMany,
} from 'typeorm';
import { BaseEntity } from './base.entity';
import { LegacyEmailActivityEntity } from './legacy-email-activity.entity';
import { LegacyEmailEntity } from './legacy-email.entity';
import { MessageEntity } from './message.entity';
import { SegmentEntity } from './segment.entity';

@Index('_email_receipt__id__fk__email__id_index', ['id', 'fkEmailId'], {})
@Index('email_segment_message', ['fkSegmentId', 'fkMessageId'], {})
@Entity('_email_receipt')
export class LegacyEmailReceiptEntity extends BaseEntity {
	@Column('int', { name: '_fk__message__id', unsigned: true })
	public fkMessageId!: number;

	@Column('int', { name: '_fk__email__id', nullable: true, unsigned: true })
	public fkEmailId!: number | null;

	@Column('varchar', { name: '_firstname', nullable: true, length: 255 })
	public firstname!: string | null;

	@Column('varchar', { name: '_lastname', nullable: true, length: 255 })
	public lastname!: string | null;

	@Column('varchar', { name: '_email', length: 255 })
	public email!: string;

	@Column('int', { name: '_reference_id', nullable: true, unsigned: true })
	public referenceId!: number | null;

	@Column('varchar', { name: '_ses_id', nullable: true, length: 255 })
	public sesId!: string | null;

	@Column('int', { name: '_fk__segment__id', nullable: true, unsigned: true })
	public fkSegmentId!: number | null;

	@Column('longtext', { name: '_error', nullable: true })
	public error!: string | null;

	@ManyToOne(() => MessageEntity, {
		createForeignKeyConstraints: false,
	})
	@JoinColumn([{ name: '_fk__message__id', referencedColumnName: 'id' }])
	public fkMessage!: MessageEntity;

	@ManyToOne(() => LegacyEmailEntity, (email) => email.emailReceipts, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk__email__id', referencedColumnName: 'id' }])
	public fkEmail!: LegacyEmailEntity | null;

	@ManyToOne(() => SegmentEntity, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk__segment__id', referencedColumnName: 'id' }])
	public fkSegment!: SegmentEntity | null;

	@OneToMany(
		() => LegacyEmailActivityEntity,
		(emailActivity) => emailActivity.fkEmailReceipt,
		{},
	)
	public emailActivities!: Array<LegacyEmailActivityEntity>;
}
